<div class="request-selection-container">
  <app-info-box title="{{ 'steps.requestSelection.title' | translate }}" description="{{ 'steps.requestSelection.description' | translate }}"></app-info-box>
  @if (inputsForm) {
    <div class="input-container" [formGroup]="inputsForm">
      <ds-input-area
        [control]="reasonInputArea"
        [placeholder]="'steps.requestSelection.texts.reasonPlaceholder' | translate"
        [label]="'steps.requestSelection.texts.reason' | translate"
      ></ds-input-area>
    </div>
  }

  <div class="recent-files-container">
    @for (card of uploadedFiles; track uploadedFiles) {
      <app-document-card [documentCardData]="card" (emitActionCard)="actionCard($event)"></app-document-card>
    }
  </div>

  @if (hasDocuments) {
    <div class="button-container">
      <ds-button [iconRight]="'/public/assets/images/Download.svg'" [text]="'steps.requestSelection.load_document' | translate" [width]="'small'" (click)="openModal()"></ds-button>
    </div>
  }
</div>
@if (hasTravel) {
  <app-assistance-form [isTravel]="true" [formType]="'general'" (assistanceFormEmitter)="assistanceFormData($event)"></app-assistance-form>
}
